import { Tables } from "@/lib/supabase";
import { SupabaseTableEnum } from "@/lib/supabase/supabaseTypes";
import { FormRule } from "./ruleTypes";

export const FIELD_TYPE_SUPPORTS_PLACEHOLDER = (fieldType: FieldType) => {
	return (
		fieldType !== "odontogram" &&
		fieldType !== "appointment" &&
		fieldType !== "time" &&
		fieldType !== "date" &&
		fieldType !== "file" &&
		fieldType !== "radio" &&
		fieldType !== "checkbox" &&
		fieldType !== "select" &&
		fieldType !== "chips"
	);
};

export type FieldType =
	| "text" // Short answer
	| "textarea" // Long answer
	| "radio" // Multiple choice
	| "checkbox" // Checkbox
	| "select" // Dropdown
	| "chips" // Single selection chips (compact, wraps)
	| "file" // File upload
	| "odontogram" // Odontogram (formerly teeth-selection)
	| "appointment" // Appointment with customizable sub-fields
	| "date" // Date
	| "time" // Time
	| "title" // Section title element
	| "description"; // deprecated - Description text element (use title with description instead)

export enum FieldTypeEnum {
	TEXT = "text",
	TEXTAREA = "textarea",
	RADIO = "radio",
	CHECKBOX = "checkbox",
	SELECT = "select",
	CHIPS = "chips",
	FILE = "file",
	ODONTOGRAM = "odontogram",
	APPOINTMENT = "appointment",
	DATE = "date",
	TIME = "time",
	TITLE = "title",
	/** @deprecated - Use title with description instead */
	DESCRIPTION = "description",
}

// Form field structure
export interface FormField {
	id: string;
	type: FieldType; // For title elements, label is the title and description is the subtitle
	label: string;

	// Used in text and textarea
	placeholder?: string;
	required: boolean;

	// Options for select, radio, checkbox, and chips fields
	options?: string[];

	// For radio and chips: when true, an extra "Sonstiges" option is appended
	// that reveals a short-answer text input. The selected value is stored as
	// "Sonstiges" (no text yet) or "Sonstiges: <user text>".
	allowOther?: boolean;

	// For chips: when true, multiple chips can be selected at once and the
	// value is stored as string[] instead of a single string.
	multi?: boolean;

	description?: string;
	defaultValue?: string | string[] | boolean;

	// For odontogram, additional dropdown fields
	odontogramFields?: FormField[];

	// For appointment field, customizable sub-fields and optional max count
	appointmentFields?: FormField[];
	maxAppointments?: number;
}

// Form section containing multiple fields
export interface FormSection {
	id: string;
	title: string;
	description?: string;
	fields: FormField[];
}

// This is what is used in forms.definition jsonb
export interface FormDefinition {
	sections: FormSection[];
}

// Form but with actualy definition instead of jsonb
export interface ExtendedFormTemplate
	extends Omit<Tables<SupabaseTableEnum.FORMS>, "definition" | "rules"> {
	definition: FormDefinition;
	rules: FormRule[];
}
